import script from "./vendor-payments.vue?vue&type=script&setup=true&lang=js"
export * from "./vendor-payments.vue?vue&type=script&setup=true&lang=js"

import "./vendor-payments.vue?vue&type=style&index=0&id=369d8e58&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-369d8e58"]])

export default __exports__